module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/3-e9a5f337026741c62bc00df4151dd443.jpg";